"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_dropzone_1 = require("react-dropzone");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_web_components_1 = require("@nimles/react-web-components");

var getBase64 = function getBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      return reader.result ? resolve(reader.result.toString()) : reject('Result is undefined');
    };

    reader.onerror = function (error) {
      return reject(error);
    };
  });
};

var ImageContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var RemoveButton = styled_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n"])));
var Image = styled_1.default.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var DropZone = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: 2px dashed ", ";\n  border-radius: ", "px;\n  padding: ", ";\n  cursor: pointer;\n"], ["\n  border: 2px dashed ", ";\n  border-radius: ", "px;\n  padding: ", ";\n  cursor: pointer;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.input.borderColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.input.borderRadius;
}, function (_a) {
  var theme = _a.theme;
  return theme.input.paddingVertical + "px " + theme.input.paddingHorizontal + "px";
});

var FileInput = function FileInput(_a) {
  var field = _a.field,
      form = _a.form,
      label = _a.label,
      placeholder = _a.placeholder,
      onFilesLoaded = _a.onFilesLoaded,
      disabled = _a.disabled,
      multi = _a.multi;

  var _b, _c, _d;

  var onDrop = function onDrop(files) {
    return __awaiter(void 0, void 0, void 0, function () {
      var values;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            files = multi ? files : [files[0]];
            return [4
            /*yield*/
            , onFilesLoaded ? onFilesLoaded(files) : Promise.all(files.map(function (file) {
              return __awaiter(void 0, void 0, void 0, function () {
                var uri;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4
                      /*yield*/
                      , getBase64(file)];

                    case 1:
                      uri = _a.sent();
                      return [2
                      /*return*/
                      , {
                        uri: uri,
                        name: file.name,
                        mimeType: file.type
                      }];
                  }
                });
              });
            }))];

          case 1:
            values = _a.sent();
            console.log('File', field.value);
            form.setFieldValue(field.name, multi ? Array.isArray(field.value) ? __spreadArrays(field.value, values) : values : values[0]);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var _e = react_dropzone_1.useDropzone({
    onDrop: onDrop
  }),
      getRootProps = _e.getRootProps,
      getInputProps = _e.getInputProps,
      isDragActive = _e.isDragActive;

  var handleRemove = function handleRemove(e) {
    e.preventDefault();
    e.stopPropagation();
    form.setFieldValue(field.name, undefined);
  };

  var handleIndexRemove = function handleIndexRemove(e, index) {
    e.preventDefault();
    e.stopPropagation();
    form.setFieldValue(field.name, field.value.filter(function (_, fileIndex) {
      return fileIndex !== index;
    }));
  };

  return disabled ? react_1.default.createElement(Image, {
    src: (_b = field.value) === null || _b === void 0 ? void 0 : _b.uri,
    alt: ""
  }) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("label", null, label), react_1.default.createElement(DropZone, __assign({
    key: field.name
  }, getRootProps()), react_1.default.createElement("input", __assign({}, getInputProps())), multi ? react_1.default.createElement(react_web_components_1.List, null, !((_c = field.value) === null || _c === void 0 ? void 0 : _c.length) ? react_1.default.createElement("p", null, placeholder) : field.value.map(function (_a, index) {
    var uri = _a.uri,
        mimeType = _a.mimeType,
        name = _a.name;

    var _b, _c, _d;

    return react_1.default.createElement(react_web_components_1.ListItem, {
      key: index
    }, react_1.default.createElement(react_web_components_1.Row, {
      wrap: "wrap",
      align: "center"
    }, react_1.default.createElement(react_web_components_1.Column, {
      padding: "0",
      xs: 20,
      align: "center"
    }, ((_c = (_b = mimeType) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.indexOf('image')) === 0 ? react_1.default.createElement(Image, {
      src: uri || undefined,
      alt: ""
    }) : (_d = mimeType) === null || _d === void 0 ? void 0 : _d.split('/').map(function (s) {
      return react_1.default.createElement("div", null, s);
    })), react_1.default.createElement(react_web_components_1.Column, {
      flex: true
    }, react_1.default.createElement("div", null, name)), react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(react_web_components_1.Button, {
      onClick: function onClick(e) {
        return handleIndexRemove(e, index);
      }
    }, "Remove"))));
  })) : !field.value ? react_1.default.createElement("p", null, placeholder) : react_1.default.createElement(ImageContainer, null, react_1.default.createElement(Image, {
    src: (_d = field.value) === null || _d === void 0 ? void 0 : _d.uri,
    alt: ""
  }), react_1.default.createElement(RemoveButton, {
    onClick: handleRemove
  }, "Remove"))));
};

exports.FileField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: FileInput
  }));
};

exports.default = exports.FileField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;